<template>
  <div class="auth-wrapper">
    <div class="auth-header">
      <div class="auth-title">
        <span
          class="auth-avator"
          :style="{background: shareInfo.profileColor}"
        >{{ getAvatorName }}</span><!--
                --><span class="user-name">{{ shareInfo.user_name }}</span><span class="user-name-tail">{{ $t('给您分享了一个文件') }}</span>
      </div>
    </div>
    <div class="auth-body">
      <div class="auth-password">
        <input
          v-model="password"
          :class="['password', authMessage.length ? 'onError' : '']"
          type="password"
          autocomplete="off"
          :placeholder="$t('请输入提取密码')"
          onpaste="return false"
          @keyup.enter="passwordAuth"
          @input="resetTip($event)"
        >
      </div>
      <div class="auth-identify clearfix" v-show="showIdentifyCode">
        <input
          v-model="identifyCode"
          :class="['identifyCode', 'fl']"
          maxlength="4"
          type="password"
          autocomplete="off"
          :placeholder="$t('请输入验证码')"
          onpaste="return false"
          @keyup.enter="passwordAuth"
        >
        <img class="identifyImg" :src="identifyImg" @click="getIdentifyImg">
        <!--<span class="reflash" @click="getIdentifyImg">{{ $t('看不清？') }}</span>-->
      </div>
    </div>
    <div class="auth-tip">
      {{ $t(authMessage) }}
    </div>
    <div :class="['auth-footer', authMessage.length ? 'margin-zero' : '']">
      <div
        class="auth-button"
        @click="passwordAuth"
      >
        {{ $t('确定') }}
      </div>
    </div>
  </div>
</template>
<script>
const { getData, postData } = require('js/api/getdata').default

export default {
  props: {
    /**
         * 链接的相关信息
         */
    shareInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      password: '', // 提取码
      authMessage: '', // 验证提示信息
      showIdentifyCode: false, // 是否展示验证码模块
      identifyCode: '', // 验证码
      identifyImg: '', // 验证码图片
    }
  },
  computed: {
    /**
         * 获取头像标识
         */
    getAvatorName() {
      const linkInfo = this.shareInfo || {}
      if (linkInfo.user_name) {
        return linkInfo.user_name && linkInfo.user_name.substr(0, 1)
      }
    },
  },
  methods: {
    // 获取公钥
    getPublicKey() {
      return getData('getPublicKey')
    },
    // 获取验证码图片
    getIdentifyImg(cb) {
      const params = {
        flag: this.$route.params.neid,
      }

      getData('getIdentifyImg', params).then((res) => {
        this.identifyImg = `data:image/jpeg;base64,${res.data.vcode_img}`
        if (Object.prototype.toString.call(cb) === '[object Function]') {
          cb()
        }
      })
    },
    /**
         * 点击“确认”按钮，验证password
         */
    passwordAuth() {
      if (!this.password.toString().length) {
        this.authMessage = '提取码不能为空'
        return
      }
      if (this.showIdentifyCode && !this.identifyCode.toString().length) {
        this.authMessage = '验证码不能为空'
        return
      }
      const params = {
        password: this.$jsEncrypt.encrypt(this.password),
      }
      if (this.showIdentifyCode) {
        params.captcha = this.identifyCode
      }
      if (this.shareInfo._id.length > 32) {
        this.shareInfo._id = this.shareInfo._id.substring(5, this.shareInfo._id.length)
      }
      postData('checkDeliveryAuth', params, { url: `/${this.shareInfo._id}` }).then((res) => {
        const token = res.data && res.data.token
        this.$emit('getPasswordToken', { token, password: this.password })
        // this.checkSmartShare(token)
        // console.log('delivery/auth=', res, token)
      }).catch((err) => {
        const errmsg = err.response.data
        if (errmsg.state === 403) {
          this.authMessage = err.response.data.message
          return
        }
        if (errmsg.state === 409) {
          this.getIdentifyImg(() => {
            this.showIdentifyCode = true
            this.authMessage = err.response.data.message
          })
          return
        }
        this.authMessage = '网络错误,请重试'
      })
    },
    // /**
    //      * 检查该外链有没有smartshare验证流程，如果有走smartshare验证流程
    //      * 如果没有，则返回token，进入外链内容页
    //      */
    // checkSmartShare(token) {
    //   if (this.shareInfo.is_smartshare && this.shareInfo.receiver_setting != 0) {
    //     this.$emit('changeToSmAuth', { token, password: this.password })
    //   } else {
    //     this.$emit('getPasswordToken', { token, password: this.password })
    //   }
    // },
    /**
         * 清除错误提示
         */
    resetTip(e) {
      // 提取码不可以输入空格
      this.password = this.password.replace(/[\W]/g, '')
      this.authMessage = ''
    },
  },
  created() {
    this.getPublicKey().then((res) => {
      this.$jsEncrypt.setPublicKey(res.data.public_key)
      localStorage.setItem('public_key', res.data.public_key)
    })
  },
}
</script>
<style lang="less" scoped>
@import '~less/auth.less';
.auth-wrapper{
  width: 400px;
  height: auto;
  padding: 38px 40px 40px 40px;
  position: absolute;
  top: calc(~"50% - 50px");
  left: 50%;
  transform: translateY(-50%);
  margin-left: -200px;
  .auth-body{
    padding: 32px 0 0 0;
    .auth-identify{
      margin-top: 12px;
      .identifyCode{
        width: 175px;
        float: left;
      }
      .identifyImg{
        width: 133px;
        height: 44px;
        float: right;
        &:hover{
          cursor: pointer
        }
      }
    }
  }
  .auth-tip {
    margin: 8px 0 16px 0;
    font-size: 12px;
    color: #FF3A34;
    line-height: 16px;
  }
  .auth-footer{
    margin: 32px 0 0 0;
    .auth-button{
      width: 320px;
      height: 44px;
      line-height: 44px;
      font-size: 16px;
    }
  }
  .margin-zero{
    margin: 0 !important;
  }
}
</style>
